import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

const StaffEdit = ({ match }) => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        Code: '',
        Email: '',
        ContactNumber: '',
        DateOfJoining: '',
        DateOfLeaving: '',
        DOB: '',
        CompanyID: '',
    });

    useEffect(() => {
        fetchData('StaffApi', `/StaffDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Staff Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // if (!formData.isSubmit) {
        //   return;
        // }

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('StaffApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/StaffIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };
    return (
        // <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={handleSubmit}>

                    <div className='w-full mb-2 flex items-center'>
                    <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>STAFF EDIT</h6>

                        <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={handleSubmit}
                        >
                            Update
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/StaffIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            Cancel
                        </Button>


                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                First Name
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                type="text"
                                placeholder="FirstName"
                                maxLength={30}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Last Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="LastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                type="text"
                                placeholder="LasttName"
                                maxLength={30}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                type="text"
                                placeholder="Code"
                                maxLength={7}
                            />
                        </div>
                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DateOfJoining
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="dateOfJoining"
                                value={formData.dateOfJoining}
                                onChange={handleChange}
                                type="date"
                                placeholder="Date of joining"

                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DOB
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="dOB"
                                value={formData.dOB}
                                onChange={handleChange}
                                type="date"
                                placeholder="Date of birth"

                            />
                        </div>
                        <div className="w-1/7 mr-3">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Ph.Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="contactNumber"
                                value={formData.contactNumber}
                                onChange={handleChange}
                                placeholder="phoneNumber"
                                maxLength={15}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Email
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email"
                                maxLength={40}
                            />
                        </div>

                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DateOfLeaving
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="dateOfLeaving"
                                value={formData.dateOfLeaving}
                                onChange={handleChange}
                                type="date"
                                placeholder="Date Of Leaving"

                            />
                        </div>

                    </div>

                </form>
            </div >
        // </Fragment >
    );
}

export default StaffEdit;


